import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Search, MapPin, UserPlus, Vote, Calendar, Mail, ExternalLink } from 'lucide-react';
const precinctData = [{
  county: 'ARLINGTON COUNTY',
  precincts: ['Precinct 102', 'Precinct 104', 'Precinct 107', 'Precinct 110', 'Precinct 111', 'Precinct 114', 'Precinct 115', 'Precinct 116', 'Precinct 117', 'Precinct 118', 'Precinct 119', 'Precinct 120', 'Precinct 123', 'Precinct 124', 'Precinct 125', 'Precinct 126', 'Precinct 129', 'Precinct 131', 'Precinct 133', 'Precinct 134', 'Precinct 135', 'Precinct 136', 'Precinct 137', 'Precinct 138', 'Precinct 139', 'Precinct 140', 'Precinct 141', 'Precinct 144', 'Precinct 145', 'Precinct 146', 'Precinct 148', 'Precinct 149', 'Precinct 151', 'Precinct 154']
}, {
  county: 'AUGUSTA COUNTY',
  precincts: ['Jolivue', 'Stuarts Draft Elem.', 'Fort Defiance', 'North River', 'Mount Solon', 'Rolla', 'Buffalo Gap', 'Churchville Elem.', 'Craigsville', 'Deerfield', 'Cedar Green', 'Middlebrook']
}, {
  county: 'CULPEPER COUNTY',
  precincts: ['West Fairfax', 'East Fairfax', 'Eggbornsville', 'Cardova', 'Willow Shade', 'Eldorado', 'Browns Store', 'Jeffersonton', 'Rixeyville', 'Mitchells', 'Pearl Sample', 'South Ridge', 'Brandy Station', 'Lignum', 'Richardsville']
}, {
  county: 'CUMBERLAND COUNTY',
  precincts: ['Precinct 1']
}, {
  county: 'FAIRFAX COUNTY',
  precincts: ['Fairview', 'Heritage', 'Kings Park', 'North Springfield', 'Ravensworth', 'Lake Braddock', 'Laurel', 'Sideburn #1', 'Signal Hill', 'Bonnie Brae', 'Burke Centre', 'Cardinal', 'Keene Mill', 'Terra Centre', 'Irving', 'Sideburn #2', 'Pimmit', 'Westhampton', 'Crestwood', 'Lynbrook #1', 'Greenspring', 'West Springfield', 'Lynbrook #2', 'Barcroft', 'Bristow', 'Glen Forest', 'Holmes', 'Masonville', 'Ravenwood', 'Sleepy Hollow', 'Saint Albans', 'Westlawn', 'Willston', 'Columbia', 'Brook Hill', 'Poe', 'Walnut Hill', 'Edsall', 'Tripps', 'Fort Buffalo', 'Woodburn', 'Graham-Greenway', 'Marshall', 'Pine Spring', 'Shreve', 'Timber Lane', 'Burke #1', 'Clifton South', 'Colchester', 'Fairfax Station', 'Hunt Valley', 'Pohick', 'Valley', 'Woodyard', 'Orange', 'Cherry Run', 'White Oaks', 'Sangster', 'Silverbrook', 'Popes Head', 'Parkway', 'Fountainhead', 'South Run', 'Sandy Run', 'Burke #2']
}, {
  county: 'FALLS CHURCH CITY',
  precincts: ['First Ward', 'Second Ward', 'Third Ward']
}, {
  county: 'FAUQUIER COUNTY',
  precincts: ['Catlett', 'Lois', 'Opal', 'Morrisville', 'Botha', 'Bealeton', 'Remington', 'Springs Valley']
}, {
  county: 'GOOCHLAND COUNTY',
  precincts: ['Fife', 'Hadensville', 'Three Square', 'Sandy Hook', 'Beaverdam', 'Randolph', 'Shallow Well', 'Centerville', 'West Creek', 'Manakin', 'Blair']
}, {
  county: 'GREENE COUNTY',
  precincts: ['Dyke', 'Swift Run', 'Ruckersville', 'Stanardsville', 'Stanardsville Town', 'Midway']
}, {
  county: 'LOUISA COUNTY',
  precincts: ['Zion', 'Mechanicsville', 'Louisa #1', 'Louisa #2', 'Louisa #3', 'Patrick Henry #1', 'Patrick Henry #2', 'Mineral', 'Fredericks Hall', 'Cuckoo (2 precincts)', 'Bumpass', 'Sheltons Mill', 'South Anna']
}, {
  county: 'MADISON COUNTY',
  precincts: ['Oak Park', 'Radiant', 'Rochelle', 'Graves Mill', 'Madison', 'Etlan', 'Brightwood', 'Criglersville']
}, {
  county: 'ORANGE COUNTY',
  precincts: ['1 West', '1 East', '1 Town', '2 West', '2 East', '3 West', '3 East', '3 Town', '4 West', '4 East', '5 South', '5 North']
}, {
  county: 'POWHATAN COUNTY',
  precincts: ['Subletts', 'Manakin', 'Flat Rock', 'Powhatan Station', 'Graceland', 'Bethesda', "Lee's Landing", 'Powhatan Courthouse', 'Mt Zion', 'Smiths Crossroads', 'Pineville', 'Tobaccoville']
}, {
  county: 'PRINCE WILLIAM COUNTY',
  precincts: ['Brentsville', 'Bennett', 'Buckhall', 'Independent Hill', 'Yates Ford', 'Lucasville']
}, {
  county: 'ROCKINGHAM COUNTY',
  precincts: ['Singers Glen', 'Edom', 'Dayton', 'Mt Clinton', 'Silver Lake', 'Keezletown', 'Melrose', 'West Bridgewater', 'Montezuma', 'Mt Crawford', 'North River', 'Ottobine', 'East Bridgewater', 'Elkton', 'Swift Run', 'McGaheysville', 'South Fork', 'Stony Run']
}];
export function DistrictPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredData = precinctData.map(group => {
    const matchesCounty = group.county.toLowerCase().includes(searchTerm.toLowerCase());
    const matchingPrecincts = group.precincts.filter(p => p.toLowerCase().includes(searchTerm.toLowerCase()));
    if (matchesCounty) return group;
    if (matchingPrecincts.length > 0) return {
      ...group,
      precincts: matchingPrecincts
    };
    return null;
  }).filter(Boolean);
  return <div className="min-h-screen bg-warmgray font-sans text-navy selection:bg-red selection:text-white" data-id="element-284">
      <Navbar alwaysSolid data-id="element-285" />

      <main className="pt-28 pb-24" data-id="element-286">
        {/* Hero Section */}
        <section className="bg-navy py-20 md:py-32 px-6 md:px-12 text-center relative overflow-hidden" data-id="element-287">
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-sky via-transparent to-transparent" data-id="element-288"></div>
          <div className="max-w-4xl mx-auto relative z-10" data-id="element-289">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-290">
              <h1 className="text-5xl md:text-7xl font-serif text-white mb-8 leading-tight" data-id="element-291">
                About Virginia's 7th{' '}
                <span className="italic text-sky" data-id="element-292">Congressional District</span>
              </h1>
              <p className="text-xl text-white/80 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-293">
                From Rockingham to Arlington to Powhatan, Elizabeth is fighting
                for you. Elizabeth is the{' '}
                <span className="font-bold underline" data-id="element-294">ONLY</span> candidate in
                the race who has represented rural, suburban, and urban areas.
              </p>
            </motion.div>
          </div>
        </section>

        {/* District Map */}
        <section className="max-w-5xl mx-auto px-6 md:px-12 py-24" data-id="element-295">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center" data-id="element-296">
            <span className="text-red font-bold tracking-widest uppercase text-sm block mb-4" data-id="element-297">
              District Lines
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-8" data-id="element-298">
              Virginia's 7th{' '}
              <span className="italic text-sky" data-id="element-299">Congressional District</span>
            </h2>

            <p className="text-lg text-navy/80 font-light leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-300">
              Virginia's 7th stretches from the bustling neighborhoods of
              Arlington and Fairfax County through the historic city of Falls
              Church, across the rolling horse country of Fauquier and Culpeper,
              into the small towns of Orange, Madison, and Greene counties, and
              deep into the Shenandoah Valley communities of Augusta and
              Rockingham. It reaches south through Louisa, Goochland, and
              Powhatan toward the Richmond suburbs. It is one of the most
              geographically and economically diverse districts in the
              Commonwealth — home to federal workers, farmers, small business
              owners, teachers, and military families alike.
            </p>

            <div className="rounded-sm overflow-hidden shadow-2xl mb-10" data-id="element-301">
              <img src="https://cdn.magicpatterns.com/uploads/1aNAhYyMQs9bBWrgTdjg6Z/Screen_Shot_2026-04-20_at_10.12.02_PM.png" alt="Proposed VA-07 Congressional District Map" className="w-full h-auto" data-id="element-302" />
            </div>

            <p className="text-[10px] text-navy/30 font-light italic" data-id="element-303">
              <a href="https://projects.statenavigate.com/25-26/states/va/ush_proposal_feb_17.html" target="_blank" rel="noopener noreferrer" className="hover:text-navy/50 transition-colors underline" data-id="element-304">
                Source: State Navigate — Virginia's Proposed 7th US House
                District
              </a>
            </p>
          </motion.div>
        </section>

        {/* Precinct List Section */}
        <section className="bg-warmgray py-24 border-t border-navy/10" data-id="element-305">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-306">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="mb-12 text-center" data-id="element-307">
              <span className="text-red font-bold tracking-widest uppercase text-sm block mb-4" data-id="element-308">
                Find Your Polling Place
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-8" data-id="element-309">
                Precincts in the{' '}
                <span className="italic text-sky" data-id="element-310">District</span>
              </h2>

              <div className="max-w-2xl mx-auto relative" data-id="element-311">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-navy/40" size={20} data-id="element-312" />
                <input type="text" placeholder="Search by county or precinct name..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-white border border-navy/10 rounded-sm pl-12 pr-4 py-4 text-navy placeholder:text-navy/40 focus:outline-none focus:border-red focus:ring-1 focus:ring-red transition-colors shadow-sm" data-id="element-313" />
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="bg-white rounded-sm shadow-xl border border-navy/5 overflow-hidden" data-id="element-314">
              <div className="max-h-[600px] overflow-y-auto p-6 md:p-8" data-id="element-315">
                {filteredData.length > 0 ? <div className="space-y-10" data-id="element-316">
                    {filteredData.map((group, index) => <div key={index} data-id="element-317">
                        <h3 className="text-xl font-bold text-red mb-4 sticky top-0 bg-white/95 backdrop-blur-sm py-2 border-b border-gray-100 z-10" data-id="element-318">
                          {group.county}
                        </h3>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-3" data-id="element-319">
                          {group.precincts.map((precinct, pIndex) => <li key={pIndex} className="text-navy/80 font-light flex items-start gap-2" data-id="element-320">
                              <span className="text-sky mt-1.5 text-[10px]" data-id="element-321">
                                ■
                              </span>
                              {precinct}
                            </li>)}
                        </ul>
                      </div>)}
                  </div> : <div className="text-center py-12 text-navy/50 font-light" data-id="element-322">
                    No precincts found matching "{searchTerm}"
                  </div>}
              </div>
            </motion.div>
          </div>
        </section>

        {/* Voting Quick Actions */}
        <section className="bg-navy py-20" data-id="element-323">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-324">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-325">
              <span className="text-red font-bold tracking-widest uppercase text-sm block mb-4" data-id="element-326">
                Make Your Voice Heard
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-white" data-id="element-327">
                Ready to <span className="italic text-sky" data-id="element-328">Vote?</span>
              </h2>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-329">
              <motion.a href="https://www.elections.virginia.gov/casting-a-ballot/polling-place-lookup/" target="_blank" rel="noopener noreferrer" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} className="bg-white/5 border border-white/10 rounded-sm p-8 flex items-center gap-6 hover:bg-white/10 transition-colors group" data-id="element-330">
                <div className="w-16 h-16 bg-red rounded-full flex items-center justify-center shrink-0" data-id="element-331">
                  <MapPin className="text-white" size={28} data-id="element-332" />
                </div>
                <div data-id="element-333">
                  <h3 className="text-xl font-bold text-white mb-1 group-hover:text-sky transition-colors" data-id="element-334">
                    Find Your Polling Place
                  </h3>
                  <p className="text-white/60 font-light text-sm flex items-center gap-1" data-id="element-335">
                    elections.virginia.gov <ExternalLink size={12} data-id="element-336" />
                  </p>
                </div>
              </motion.a>

              <motion.a href="https://www.elections.virginia.gov/registration/" target="_blank" rel="noopener noreferrer" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="bg-white/5 border border-white/10 rounded-sm p-8 flex items-center gap-6 hover:bg-white/10 transition-colors group" data-id="element-337">
                <div className="w-16 h-16 bg-sky rounded-full flex items-center justify-center shrink-0" data-id="element-338">
                  <UserPlus className="text-navy" size={28} data-id="element-339" />
                </div>
                <div data-id="element-340">
                  <h3 className="text-xl font-bold text-white mb-1 group-hover:text-sky transition-colors" data-id="element-341">
                    Register to Vote
                  </h3>
                  <p className="text-white/60 font-light text-sm flex items-center gap-1" data-id="element-342">
                    elections.virginia.gov <ExternalLink size={12} data-id="element-343" />
                  </p>
                </div>
              </motion.a>
            </div>
          </div>
        </section>

        {/* Voting Information */}
        <section className="bg-warmgray py-24" data-id="element-344">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-345">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-16" data-id="element-346">
              <span className="text-red font-bold tracking-widest uppercase text-sm block mb-4" data-id="element-347">
                Important Dates
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-navy" data-id="element-348">
                How to <span className="italic text-sky" data-id="element-349">Vote</span>
              </h2>
            </motion.div>

            <div className="grid md:grid-cols-3 gap-8" data-id="element-350">
              {/* Registration */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} className="bg-white rounded-sm p-8 shadow-sm border border-navy/5" data-id="element-351">
                <div className="w-14 h-14 bg-warmgray rounded-full flex items-center justify-center mb-6" data-id="element-352">
                  <UserPlus className="text-red" size={24} strokeWidth={1.5} data-id="element-353" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-4" data-id="element-354">
                  Register to Vote
                </h3>
                <div className="space-y-4 text-navy/70 font-light text-sm leading-relaxed" data-id="element-355">
                  <p data-id="element-356">
                    <span className="font-bold text-navy" data-id="element-357">Deadline:</span>{' '}
                    Friday, July 24, 2026
                  </p>
                  <p data-id="element-358">
                    Register or update your registration online using the{' '}
                    <a href="https://www.elections.virginia.gov/registration/" target="_blank" rel="noopener noreferrer" className="text-sky underline hover:text-navy transition-colors" data-id="element-359">
                      Citizen Portal
                    </a>
                    .
                  </p>
                  <p data-id="element-360">
                    After July 24, 2026, voters may register and vote using a
                    provisional ballot in-person through Election Day.
                  </p>
                  <p data-id="element-361">
                    Contact your{' '}
                    <a href="https://www.elections.virginia.gov/casting-a-ballot/polling-place-lookup/" target="_blank" rel="noopener noreferrer" className="text-sky underline hover:text-navy transition-colors" data-id="element-362">
                      local registrar's office
                    </a>{' '}
                    for more information.
                  </p>
                </div>
              </motion.div>

              {/* Early Voting */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.15
            }} className="bg-white rounded-sm p-8 shadow-sm border border-navy/5" data-id="element-363">
                <div className="w-14 h-14 bg-warmgray rounded-full flex items-center justify-center mb-6" data-id="element-364">
                  <Calendar className="text-red" size={24} strokeWidth={1.5} data-id="element-365" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-4" data-id="element-366">
                  Early, In-Person Voting
                </h3>
                <div className="space-y-4 text-navy/70 font-light text-sm leading-relaxed" data-id="element-367">
                  <p data-id="element-368">
                    <span className="font-bold text-navy" data-id="element-369">Period:</span> Friday,
                    June 19, 2026 through 5:00 p.m., Saturday, August 1, 2026
                  </p>
                  <p data-id="element-370">
                    Voter registration offices will be open for early voting on{' '}
                    <span className="font-medium text-navy" data-id="element-371">
                      Saturday, July 25, 2026
                    </span>
                    .
                  </p>
                </div>
              </motion.div>

              {/* Mail-in Ballot */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="bg-white rounded-sm p-8 shadow-sm border border-navy/5" data-id="element-372">
                <div className="w-14 h-14 bg-warmgray rounded-full flex items-center justify-center mb-6" data-id="element-373">
                  <Mail className="text-red" size={24} strokeWidth={1.5} data-id="element-374" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-4" data-id="element-375">
                  Mail-in Ballot
                </h3>
                <div className="space-y-4 text-navy/70 font-light text-sm leading-relaxed" data-id="element-376">
                  <p data-id="element-377">
                    <span className="font-bold text-navy" data-id="element-378">Deadline:</span> 5:00
                    p.m., Friday, July 24, 2026
                  </p>
                  <p data-id="element-379">
                    Your request must be received by your local registrar's
                    office by 5:00 p.m.
                  </p>
                  <p data-id="element-380">
                    Apply for an absentee ballot online using the{' '}
                    <a href="https://www.elections.virginia.gov/registration/" target="_blank" rel="noopener noreferrer" className="text-sky underline hover:text-navy transition-colors" data-id="element-381">
                      Citizen Portal
                    </a>
                    .
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Election Day Banner */}
        <section className="bg-navy py-20 md:py-28 px-6 md:px-12 text-center relative overflow-hidden" data-id="element-382">
          <div className="absolute inset-0 pointer-events-none" data-id="element-383">
            <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-red/20 rounded-full blur-[120px]" data-id="element-384"></div>
            <div className="absolute bottom-[-20%] right-[-10%] w-[500px] h-[500px] bg-sky/10 rounded-full blur-[120px]" data-id="element-385"></div>
          </div>
          <div className="max-w-4xl mx-auto relative z-10" data-id="element-386">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} data-id="element-387">
              <span className="inline-block bg-red text-white font-bold text-sm tracking-widest uppercase px-5 py-2 rounded-full mb-8" data-id="element-388">
                Mark Your Calendar
              </span>
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white leading-tight mb-4" data-id="element-389">
                Election Day
              </h2>
              <p className="text-2xl md:text-3xl text-sky font-serif italic mb-2" data-id="element-390">
                Tuesday, August 4th, 2026
              </p>
              <p className="text-xl text-white/70 font-light mb-10" data-id="element-391">
                Polls open 6:00 AM – 7:00 PM
              </p>
              <a href="https://www.elections.virginia.gov/casting-a-ballot/polling-place-lookup/" target="_blank" rel="noopener noreferrer" className="inline-block bg-red hover:bg-red-light text-white font-bold text-sm tracking-widest uppercase px-10 py-4 rounded-sm transition-colors shadow-lg" data-id="element-392">
                Find Your Polling Place
              </a>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer data-id="element-393" />
    </div>;
}